import { useState, useEffect } from 'react';
import { getDocs, collection, query, where } from 'firebase/firestore';
import { db } from '../../firebase';

export const Absences = (props) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const userQuery = query(collection(db, 'users'), where('estadoSesion', '!=', 'Deshabilitado'));

      if (query) {
        const users = await getDocs(userQuery);

        var arrUsers = [];
        for (const user of users.docs) {
          await getDocs(query(collection(db, 'users', user.id, 'ausencias'), where('status', '==', 'Aceptado'), where('year', '==', new Date().getFullYear().toString()))).then(
            (documents) => {
              documents.forEach((doc) => {
                const data = doc.data();
                if (!data?.startDate || !data?.endDate) return;

                // Parsear "DD/MM/YYYY" -> números
                const [sd, sm, sy] = data.startDate.split('/').map(Number);
                const [ed, em, ey] = data.endDate.split('/').map(Number);

                // Construir fechas en hora local (evita UTC)
                const start = new Date(sy, sm - 1, sd, 0, 0, 0, 0); // inicio del día
                const end = new Date(ey, em - 1, ed, 23, 59, 59, 999); // fin del día

                const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0);

                if (today >= start && today <= end) {
                  arrUsers.push({
                    uid: user.id,
                    displayName: user.data().displayName,
                    photoURL: user.data().photoURL,
                  });
                }
              });
            }
          );
        }

        arrUsers.sort((a, b) => (a.displayName > b.displayName ? 1 : b.displayName > a.displayName ? -1 : 0));
        setUsers(arrUsers);
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className='card'>
      <div className='card-body'>
        <div className='row'>
          <div className='col mt-0'>
            <h5 className='card-title'>Ausencias</h5>
          </div>
          <div className='col-auto'>
            <div className='avatar'>
              <div className='avatar-title'>
                <i class='fa-solid fa-users'></i>
              </div>
            </div>
          </div>
        </div>
        <div className='d-flex gap-2 mt-3 mb-2 ms-2 overflow-auto'>
          {loading ? (
            <div className='d-flex align-items-center ps-3'>. . .</div>
          ) : users.length === 0 ? (
            <div className='d-flex align-items-center'>No hay ausencias hoy</div>
          ) : null}

          {users.map((user) => (
            <div key={user.uid} className='avatar'>
              <img src={user.photoURL || '/defaultAvatar.png'} alt={user.displayName} className='avatar rounded-circle mb-2' title={user.displayName} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
